import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=43557eea&scoped=true&"
import script from "./followUp.vue?vue&type=script&lang=js&"
export * from "./followUp.vue?vue&type=script&lang=js&"
import style0 from "./followUp.vue?vue&type=style&index=0&id=43557eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43557eea",
  null
  
)

export default component.exports